import PropTypes from 'prop-types';
import React from 'react';

import CancelButton from 'components/buttons/Cancel';
import ConfirmButton from 'components/buttons/Confirm';
import Card from 'components/Card';
import CardActions from 'components/Card/Actions';
import CardHeader from 'components/Card/Header';
import CardText from 'components/Card/Text';
import Dialog from 'components/Dialog';
import RowSpacer from 'components/RowSpacer';

const styles = {
  card: {},
};

const CommunityLeaveDialog = ({ onConfirm, onCancel, open }) => (
  <Dialog modal onRequestClose={onCancel} open={open}>
    <Card style={styles.card}>
      <CardHeader
        titleStyle={{ fontSize: '1rem !important' }}
        title='Are you sure you want to leave? '
      />
      <CardText noTopPadding>
        The chance to win sweepstakes, sample great products, get tips, hints
        and more are for community members only.
      </CardText>
      <CardActions noTopPadding>
        <CancelButton secondary onClick={onCancel} />
        <RowSpacer />
        <ConfirmButton label='Leave' primary onClick={onConfirm} />
      </CardActions>
    </Card>
  </Dialog>
);

CommunityLeaveDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default CommunityLeaveDialog;
